var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',{staticClass:"input-field",domProps:{"value":_vm.toInputValue(_vm.value)},on:{"input":_vm.onInput}},[_c('option',{domProps:{"value":null}}),_c('option',{attrs:{"value":"false"}},[_vm._v(" false ")]),_c('option',{attrs:{"value":"true"}},[_vm._v(" true ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }